
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.133 7.133V24.2h14.934V12.287l-5.15-5.154H8.133zM6 5h12.802l6.398 6.404v14.93H6V5z","fill":"#737791"}}),_c('path',{attrs:{"d":"M15.6 10.333h-5.333v2.134H15.6v-2.134zm5.333 4.267H10.267v2.133h10.666V14.6zm0 4.267H10.267V21h10.666v-2.133zM17.733 5h1.063l6.404 6.402v1.065h-7.467V5zM22 10.333L19.866 8.2v2.133H22z","fill":"#737791"}})])
          )
        }
      }
    